import commonUtil from '../../../../../utils/commonUtil';

export const initShowContenWapDataLayer = ({ eventId, itemData, previousQuantity, index, categoryName }) => {
  const dataLayer = {
    event: 'view_item',
    seccion: 'Mesa de regalos',
    phase: 'Mesa de regalos',
    phase_detail: 'Lista del festejado',
    list: `${eventId} | Lista mesa`,
    value: `${itemData.salePrice}`,
    currency: 'MXN',
    items: [{
      item_id: itemData.skuId,
      item_variant: itemData.skuId,
      item_name: itemData.name,
      item_category: categoryName,
      price: itemData.salePrice,
      original_price: itemData.listPrice,
      quantity: previousQuantity,
      gift_list_number: `${eventId}`,
      index: `${index + 1}`,
    }],
  };
  window.dataLayer.push(dataLayer);
};

export const handleClickItemDataLayer = ({ eventId, itemData, categoryName, index }) => {
  const dataLayer = {
    event: 'select_item',
    seccion: 'Mesa de regalos',
    phase: 'Mesa de regalos',
    phase_detail: 'Lista',
    item_list_name: 'Lista de festejado',
    list: `${eventId} | Lista mesa`,
    specific_generator: 'Y',
    generator_type: 'Lista Mesa',
    generator_value: `${eventId}`,
    items: [{
      item_id: itemData.skuId,
      item_variant: itemData.skuId,
      item_name: itemData.name,
      item_category: categoryName,
      price: itemData.salePrice,
      original_price: itemData.listPrice,
      quantity: itemData.quantity,
      gift_list_number: `${eventId}`,
      item_list_index: `${index + 1}`,
    }],
  };
  window.dataLayer.push(dataLayer);
};

export const addItemToCartDataLayer = ({ data, category, index }) => ({
  event: 'add_to_cart',
  value: `${data.productInfo.quantity * data.productInfo.salePrice}`,
  currency: 'MXN',
  phase: 'Lista de regalos',
  phase_detail: 'Agregar a mi bolsa',
  seccion: 'Mesa de regalos',
  items: [{
    affiliation: 'Liverpool',
    item_id: `${data.productInfo.skuId}`,
    item_variant: `${data.productInfo.skuId}`,
    item_name: `${data.productInfo.productName}`,
    item_brand: '',
    item_category: `${category}`,
    price: `${data.productInfo.salePrice}`,
    quantity: `${data.productInfo.quantity}`,
    index,
    promotion_name: '',
    numero_mesa: `${data.eventInfo.eventId}`,
    original_price: `${data.productInfo.listPrice}`,
    item_color: `${data.productInfo.color ? data.productInfo.color : ''}`,
    item_size: `${data.productInfo.size ? data.productInfo.size : ''}`,
    gif_list_number: `${data.eventInfo.eventId}`,
  }],
});

export const addItemToCartAditionalDataLayer = ({ labels, count, quantity, status }) => ({
  event: 'alerta',
  phase: 'Lista del festejado',
  step: 'Agregar a la bolsa',
  mensaje: `${commonUtil.getLabel(labels.GuestviewPage, 'guestview.you.added.by.label')} ${count} ` +
  commonUtil.getLabel(labels.GuestviewPage, quantity < 2 ? 'guestview.product.by.label' : 'guestview.products.by.label') + ' ' +
  commonUtil.getLabel(labels.GuestviewPage, 'guestview.to.your.bag.by.label'),
  mensaje_servicio: `${status}`,
  seccion: 'Mesa de regalos',
  tipo: 'pop-up',
});

export const handleUserExpressCheckoutBuyDataLayer = ({ data, category, index }) => ({
  event: 'add_to_cart',
  seccion: 'Mesa de regalos',
  phase: 'Lista de regalos',
  phase_detail: 'Comprar ahora',
  value: `${data.productInfo.quantity * data.productInfo.salePrice}`,
  currency: 'MXN',
  items: [{
    affiliation: 'Liverpool',
    item_id: `${data.productInfo.skuId}`,
    item_variant: `${data.productInfo.skuId}`,
    item_name: `${data.productInfo.productName}`,
    item_brand: '',
    item_category: category,
    price: `${data.productInfo.salePrice}`,
    quantity: `${data.productInfo.quantity}`,
    index,
    promotion_name: '',
    numero_mesa: `${data.eventInfo.eventId}`,
    original_price: `${data.productInfo.listPrice}`,
    item_color: `${data.productInfo.color ? data.productInfo.color : ''}`,
    item_size: `${data.productInfo.size ? data.productInfo.size : ''}`,
    gif_list_number: `${data.eventInfo.eventId}`,
  }],
});
